// Dependencies
require("webstrap/type");
require("element/rich-text");

// Styles
require("./heading.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/heading/index.js
 ** module id = 106
 ** module chunks = 0 1
 **/